import chatController from '~/config/server/chat-service/chat.controller';
export var chatService = {
    chatController: chatController
};
